import request from '@/utils/request'

let Certificate_certificateApi = {
    
     getJzList(data) {
    return request._post('/shop/plus.certificate_certificate.Index/getDatezs', data);
},

  /*必备证书列表*/
  list(data) {
    return request._post('/shop/plus.certificate_certificate.Index/index', data);
},
/*添加必备证书*/
add(data) {
    return request._post('/shop/plus.certificate_certificate.Index/add', data);
},
/*修改必备证书*/
edit(data) {
    return request._post('/shop/plus.certificate_certificate.Index/edit', data);
},
/*删除必备证书*/
del(data) {
    return request._post('/shop/plus.certificate_certificate.Index/del', data);
},
/*必备证书详情*/
detail(data) {
  return request._post('/shop/plus.certificate_certificate.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.certificate_certificate.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.certificate_certificate.Setting/getSetting', data, errorback);
    },
}
export default Certificate_certificateApi;



// WEBPACK FOOTER //
// ./src/api/certificate_certificate.js